function getVariantCurrent() {

    let productVariantsList = $('.product').data('variants');

    if (productVariantsList.length > 1) {
        let selected = [];

        $('.area-variants select').each(function () {

            selected.push([
                $(this).data('id'),
                $(this).find('option').filter(':selected').val()]);
        });

        for (let i = 0; i < productVariantsList.length; ++i) {

            let variant = productVariantsList[i].variant_ids_list,
                match = true;
            for (let ii = 0; ii < selected.length; ++ii) {
                if (variant[selected[ii][0]] != selected[ii][1]) {
                    match = false;
                }
            }
            if (match) {
                return productVariantsList[i];
            }
        }
    } else {
        return productVariantsList[0];
    }

    return false;
}

function getVariantByIds(variantsIdList) {

    let productVariantsList = $('.product').data('variants');

    for (let i = 0; i < productVariantsList.length; ++i) {

        let idList = productVariantsList[i].variant_ids_list,
            isMatch = true;

        for (let ii = 0; ii < variantsIdList.length; ++ii) {
            if (idList[variantsIdList[ii][0]].length == 0) {
                isMatch = false;
            } else {

                if (parseInt(idList[variantsIdList[ii][0]]) != variantsIdList[ii][1]) {
                    isMatch = false;
                }
            }
        }

        if (isMatch) {
            return productVariantsList[i];
        }
    }

    return false;
}
function updateVariants(clicked) {
    let question,
        element,
        state,
        variantId,
        variantValueId,
        variantids,
        t;

    $('.area-variants select').each(function () {

        variantId = $(this).data('id'),
            variantValueId = parseInt($(this).find('option').filter(':selected').val());

        //loop other variant selectboxes
        variantids = [];
        $('.area-variants select').not("[data-id=" + variantId + "]").each(function () {

            variantids.push([
                $(this).data('id'),
                parseInt($(this).find('option').filter(':selected').val())
            ]);
        });

        $(this).find('option').not('[value=' + variantValueId + ']').each(function () {

            t = getVariantByIds(variantids.concat([[
                variantId,
                $(this).data('id')
            ]]));

            $(this).attr('disabled', t.status == 'disabled'
                ? true
                : false);
        });
    });

    let variant = getVariantCurrent(),
        priceMainOrigin,
        priceMain,
        priceOther,
        priceMainFrom;

    $('.product-variant-sku').html(variant.sku);

    if (parseFloat(variant.price) == 0.00) {

        $('.price .label').addClass('d-none');
        $('.price .main').addClass('d-none');
        $('.price .other').addClass('d-none');
        $('.price .price-none').removeClass('d-none');

    } else {

        $('.price .label').removeClass('d-none');
        $('.price .main').removeClass('d-none');
        $('.price .other').removeClass('d-none');
        $('.price .price-none').addClass('d-none');

        priceMain = variant.price_excl;
        priceMainOrigin = variant.price_excl;
        priceMainFrom = variant.price_from_excl;
        priceOther = variant.price_incl;

        if (config.webshop.type == 'B2C') {
            priceMain = variant.price_incl;
            priceMainOrigin = variant.price_incl;
            priceMainFrom = variant.price_from_incl;
            priceOther = variant.price_excl;
        }

        if ($('.product').data('discount') !== "") {
            priceMain = priceMain * ((100 - parseFloat($('.product').data('discount'))) / 100);
        }
        $('.price .main .amount')
            .attr('data-price', parseFloat(priceMain).toFixed(2))
            .data('price', parseFloat(priceMain).toFixed(2));

        $('.price .main .amount .product-price-span')
            .html(getLocalePrice(priceMain, 0));

        if (priceMainFrom == 0) {
            $('.price .main .amount .price-from-strike').parent().addClass('d-none');
            $('.price-from').parent().addClass('d-none');

            if ($('.product').data('discount') !== "") {
                $('.price .main .amount .price-from-strike').parent().removeClass('d-none');
                $('.price-from').parent().removeClass('d-none');
                $('.price-from').html(getLocalePrice(priceMainOrigin - priceMain));
                $('.price .main .amount .price-from-strike')
                    .html(getLocalePrice(priceMainOrigin, 0));

            }
        } else {
            $('.price .main .amount .price-from-strike').parent().removeClass('d-none');
            $('.price-from').removeClass('d-none');
            $('.price-from').html(getLocalePrice(priceMainFrom - priceMain));
            $('.price .main .amount .price-from-strike')
                .html(getLocalePrice(priceMainFrom, 0));
        }

        if ($('.price .other').length > 0) {
            $('.price .other .amount .product-price-span').html(getLocalePrice(priceOther, 0));
        }
    }

    if (variant.images.length > 0) {
        let image = config.domain + '/media/products/' + variant.images[0].table_item_id + '/' + variant.images[0].image_src;

        $('#image-main').attr('src', image);
        $('#image-main').parents('.carousel__slide').attr('data-src', image);
    } else {
        $('#image-main').attr('src', $('#image-main').data('src'));
    }
}

let changing = false;
let toggleDraggable = false;

function setContent() {

    if ($('#page .area-images')[0] == null) {
        return false;
    }

    if (!changing && !toggleDraggable) {

        changing = true;

        let hasSample = false,
            images = $($('#page .area-images')[0].outerHTML),
            sample;

        if ($('.area-sample').length > 0) {
            sample = $($('#page .area-sample')[0].outerHTML);
            hasSample = true;
            $('#page .area-sample').remove();
        }
        $('#page .area-images').remove();

        if ($(window).width() <= 575) {
            images.insertAfter('#page .area-title');
            if (hasSample) {
                sample.insertAfter('#page .area-usps');
            }

        } else {
            $('#page .columns > .left').prepend(images);
            if (hasSample) {
                $('#page .columns > .left').append(sample);
            }
        }

        changing = false;
    }
}

function setFancybox() {
    let mainCarousel;
    let currentCarousel;

    if ($("#mainCarousel").length == 0) {
        return false;
    }

    if (document.querySelector("#mainCarousel") == null) {
        return false;
    }

    mainCarousel = new Carousel(document.querySelector("#mainCarousel"), {
        Dots: false,
        on: {
            ready: (fancybox, slide) => {
                // Call fix after init.
                fixCarouselScroll("#mainCarousel");
            },
        }
    });

    currentCarousel = mainCarousel;

    if (document.querySelector("#thumbCarousel") == null) {
        return false;
    }
    const thumbCarousel = new Carousel(document.querySelector("#thumbCarousel"), {
        Sync: {
            target: currentCarousel,
            friction: 0,
        },
        Dots: false,
        Navigation: false,
        center: false,
        slidesPerPage: 1,
        infinite: false,
        on: {
            ready: (fancybox, slide) => {

                // Call fix after init.
                fixCarouselScroll("#thumbCarousel");
            },
        }
    });
    Fancybox.bind('[data-fancybox="gallery"]', {

    });
}

function fixCarouselScroll(selector) {

    // Chrome/webkit only fix
    // const isChrome = !!window.chrome;
    // const isWebkit = /AppleWebKit/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    
    // if (!isChrome && !isWebkit) return;

    const el = document.querySelector(selector);
    if (!el) return;

    // Desktop scrolling
    let scrolling = false;
    
    el.addEventListener("wheel", function(e) {
        e.stopPropagation();
        
        if (!scrolling) {
            scrolling = true;
            requestAnimationFrame(function tick() {
                window.scrollBy(0, e.deltaY * 0.6); // 0.3 = smooth factor.
                scrolling = false;
            });
        }
    }, { passive: true });

    // mobile/touch
    let startY = 0;
    let startScrollY = 0;

    el.addEventListener("touchstart", function(e) {
        startY = e.touches[0].clientY;
        startScrollY = window.scrollY;
    }, { passive: true });

    el.addEventListener("touchmove", function(e) {
        const deltaY = startY - e.touches[0].clientY;
        window.scrollTo(0, startScrollY + deltaY);
    }, { passive: true });
}

function setCardMaxHeight(element) {
    let maxHeight = 0;
    $(element).each(function () {
        if ($(this).outerHeight() > maxHeight) {
            maxHeight = $(this).outerHeight();
        }
    });
    $(element).height(maxHeight);
}


$(document).ready(function () {
    $("#quantity").on("change", function () {
        self.updateUrl();
    });

    $(window).keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });

    if ($(window).width() <= 768) {

        $(".imagewebwinkel").clone().appendTo(".webimageholder");

    }

    $(document).on('change', '.area-variants select', function () {
        updateVariants();
    });

    if ($('.area-variants select').length > 0) {
        updateVariants();
    }

    let owlRelated = $('.carousel-related').owlCarousel({
        items: 2,
        slideBy: 1,
        margin: 15,
        touchDrag: true,
        pullDrag: true,
        mouseDrag: true,
        dots: true,
        nav: false,
        responsive: {
            768: {
                items: 3,
                margin: 15
            },
            992: {
                items: 4,
                margin: 30
            }
        }

    });

    if ($('.carousel-alternatives').length > 0) {
        let owlAlternative = $('.carousel-alternatives').owlCarousel({
            items: 2,
            slideBy: 1,
            margin: 15,
            touchDrag: true,
            pullDrag: true,
            mouseDrag: true,
            dots: true,
            nav: false,
            responsive: {
                768: {
                    items: 3,
                    margin: 15
                },
                992: {
                    items: 4,
                    margin: 30
                }
            }

        });

        if (typeof document.fonts !== 'undefined' &&
            typeof document.fonts.ready !== 'undefined') {

            document.fonts.ready.then(function () {
                setCardMaxHeight('.card-product-alternative');
            });
        } else {
            setTimeout(function () {
                setCardMaxHeight('.card-product-alternative');
            }, 1500)
        }
    }

    if (typeof document.fonts !== 'undefined' &&
        typeof document.fonts.ready !== 'undefined') {

        document.fonts.ready.then(function () {
            setCardMaxHeight('.card-product-related');
            setCardMaxHeight('.card-product-gift');
        });
    } else {
        setTimeout(function () {
            setCardMaxHeight('.card-product-related');
            setCardMaxHeight('.card-product-gift');
        }, 1500)
    }

    let owlGift = $('.carousel-gift').owlCarousel({
        items: 2,
        slideBy: 1,
        margin: 15,
        touchDrag: true,
        pullDrag: true,
        mouseDrag: true,
        dots: true,
        nav: false,
        responsive: {
            768: {
                items: 3,
                margin: 15
            },
            992: {
                items: 4,
                margin: 30
            }
        }

    });

    if ($('.last-visited').length > 0) {
        let owlLastVisited = $('.carousel-last-visited').owlCarousel({
            items: 2,
            slideBy: 1,
            margin: 15,
            touchDrag: true,
            pullDrag: true,
            mouseDrag: true,
            dots: true,
            nav: false,
            responsive: {
                768: {
                    items: 3,
                    margin: 15
                },
                992: {
                    items: 4,
                    margin: 30
                }
            }

        });

        if (typeof document.fonts !== 'undefined' &&
            typeof document.fonts.ready !== 'undefined') {

            document.fonts.ready.then(function () {
                setCardMaxHeight('.card-product-last-visited');
            });
        } else {
            setTimeout(function () {
                setCardMaxHeight('.card-product-last-visited');
            }, 1500)
        }
    }

    $(document).on('change keyup input', '#quantity', function () {

        let pricesGraduated = $('.product').data('prices-graduated'),
            priceIsset = false,
            price,
            priceExcl,
            priceIncl,
            priceMain,
            discountAmount,
            priceOther;

        if (pricesGraduated != 'false' && pricesGraduated != false) {
            for (let i = 0; i < pricesGraduated.length; ++i) {
                if (parseInt(pricesGraduated[i].amount_start) <= $(this).val() &&
                    parseInt(pricesGraduated[i].amount_end) >= $(this).val()) {
                    priceExcl = pricesGraduated[i].price_excl;
                    priceIsset = true;
                }
            }

            if (!priceIsset) {
                priceExcl = pricesGraduated[pricesGraduated.length - 1].price_excl;
            }

            priceExcl = parseFloat(getPrice(priceExcl, 0).replace(",", "."));

            if (config.webshop.prices.display.type == 'incl') {
                priceMain = getPrice(priceExcl, $('.product').data('vatrate'));
                priceOther = getPrice(priceExcl, 0);
            } else {
                priceMain = getPrice(priceExcl, 0);
                priceOther = getPrice(priceExcl, $('.product').data('vatrate'));
            }

            discountAmount = $(this).data('discount');
            if (discountAmount !== undefined && discountAmount > 0 && discountAmount !== "") {
                priceMain = parseFloat(priceMain.replace(',', '.')) * ((100 - parseFloat(discountAmount)) / 100);
                priceMain = getPrice(priceMain, 0);
            }

            let span = $('.price .main .amount span.product-price-span');
            if (span.length > 0) {
                span.html(getCurrency() + " " + priceMain);
            } else {
                $('.price .main .amount').html(getCurrency() + " " + priceMain);
            }

            if ($('.price .other').length > 0) {
                $('.price .other .amount').html(getCurrency() + " " + priceOther);
            }
        }
    });


    $(document).on('change', '.variant-bundle', function () {

        window.location.href = $(this).children("option:selected").data('url');
    });


    if ($('.product-header').length > 0) {
        $(window).scroll(function () {
            if ($(document).scrollTop() > 181) {
                $('.product-header').addClass('active');
            } else {
                $('.product-header').removeClass('active');
            }
        });
    }

    $(window).on('resize', function () {
        setContent();
        setFancybox();
    });

    setContent();
    setFancybox();

    $(document).on('click', '.btn-product-subscribe', function (e) {
        e.preventDefault();

        let parent = $(this).parents('.area-subscribe');

        $.ajax({
            url: config.domain + '/frontend/functions/products_subscribe.php?action=1',
            type: 'POST',
            dataType: 'json',
            data: {
                email: parent.find('#subscribe-email').val(),
                product_id: $('#product_id').val(),
                token: $('#csrf-token').val()
            },
            'success': function (response) {

                $('.area-subscribe .alert').remove();

                let str = `
                <div class="alert alert-${response.message.type}">
                    <button type="button" class="close" data-dismiss="alert">&times;</button >
                    ${response.message.text}
                </div>`;
                $('.area-subscribe .alerts').append(str);

                $('.area-subscribe #subscribe-email').val('');
            }
        });
    });

    loadParams();
});

/**
 * Updates the physical url of the page
 */
function updateUrl() {
    let path = `${window.location.origin}${window.location.pathname}`;
    setTimeout(() => {
        if (constructUrlData() !== "") {
            path += `?${constructUrlData()}`;
        }

        window.history.replaceState(null, null, path);
    }, 200);
}

/**
 * Constructs url parameters based on user input
 * @returns {string} url parameters
 */
function constructUrlData() {
    let checkedOptions = [];
    let accessoriesQuantities = {}; 

    $('[name="pc_options[]"]:checked').each(function () {
        let optionId = $(this).val();
        checkedOptions.push(optionId);

        if($(`#pc-options-quantity-${optionId}`).length > 0) {
            let quantity = 1;
            // find the quantity input with the same id using the value of the pc_option.
            let $quantityInput = $(`#pc-options-quantity-${optionId}`);
            
            if ($quantityInput.length) {
                quantity = $quantityInput.val();
                if(!quantity || quantity <= 0) {
                    quantity = 1;
                }
            }

            accessoriesQuantities[optionId] = parseInt(quantity);
        }
    });

    let data = {
        width: $('#pc-width').val(),
        height: $('#pc-height').val(),
        options: checkedOptions.join(','),
        options_quantities: Object.entries(accessoriesQuantities)
            .map(([id, quantity]) => `${id}:${quantity}`)
            .join('|'),
        print_id: $('#pc-print').val(),
        shape_id: $('#pc-shape').val(),
        quantity: $('#quantity').val(),
    }

    if ($('#cart-item-id').val() !== "") {
        data = {
            ...data,
            cart_item_id: $('#cart-item-id').val(),
        }
    }

    // remove empty values from parameter string
    Object.keys(data).forEach(key => {
        if (data[key] == "" || data[key] == null) {
            delete data[key];
        }

        if (data[key] == "0") {
            delete data[key];
        }
    });

    let params = new URLSearchParams(data);

    return params.toString();
}

function loadParams() {
    return new Promise((resolve, reject) => {
        const params = new URLSearchParams(window.location.search);

        if (params.size == 0) {
            return;
        }

        let fields = [
            'pc-width',
            'pc-height',
            'print_id',
            'shape_id',
            'quantity',
            'cart-item-id',
        ];
        let shouldTriggerQuantityUpdate = false;

        fields.forEach(field => {
            let paramKey = field.replace('pc-', '');
            let value = params.get(paramKey);

            if (value == null && paramKey === 'cart-item-id') {
                value = params.get('cart_item_id');
            }

            if (value == null) {
                return;
            }

            let inputKey = paramKey;
            if ($.inArray(paramKey, ['print_id', 'shape_id']) !== -1) {
                inputKey = paramKey.replace('_id', '');
            }

            if (value == "0") {
                value = "";
            }

            if (inputKey === 'quantity' && value !== "") {
                shouldTriggerQuantityUpdate = true;
            }

            if (inputKey === 'quantity' || inputKey === 'cart-item-id') {
                $('#' + inputKey).val(value);
            } else {
                $('#pc-' + inputKey).val(value);
            }
        });

        if (shouldTriggerQuantityUpdate) {
            $('#quantity').trigger('change');
        }

        // options checkboxes
        if (params.has('option_ids') || params.has('options')) {
            let options = params.get('option_ids') ?? params.get('options');
            options.split(',').forEach(value => {
                $('#pc-options-' + value)
                    .attr('checked', true)
                    .prop('checked', true);
            });
        }

        // options quantities (33:1,34:5)
        if (params.has('options_quantities')) {
            let optionsQuantities = params.get('options_quantities');

            optionsQuantities
                .split(/[|,]/) // split by | OR ,
                .forEach(pair => {
                    let [id, qty] = pair.split(':');
                    $('#pc-options-quantity-' + id).val(qty);
                });
        }

        resolve();
    });
}
